import React from "react"
import { Box, Container, Flex, Grid, Heading, Text, Image } from "theme-ui"
import AnimateText from "./animateText"
import RichContentStructuredText from "./richContentStructuredText"
import SlideInComponent from "./slideInComponent"

const HomeAboutUsPartOne = ({ block }) => {
  const { title, body } = block.content

  return (
    <Box
      sx={{
        mb: [3, 4, 4, 5],
        height: "100%",
        zIndex: 99,
        backgroundColor: "primary",
      }}
      className="home_animation_one_container"
    >
      <Grid columns={[1, 1, 2, 2]} gap={0} sx={{ height: "100%" }}>
      <Box sx={{ display:["none","none","block"]}}></Box>
        <Container
          sx={{
            paddingRight: [3, 3, 8, 9],
            p: { fontSize: [3, 3, 3, 4] },
          }}
        >
          <Flex
            sx={{
              height: "100%",
              alignItems: "space-between",
              pt: [6,6,8, 8],
              pb: [6, 6],
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                p: {
                  fontSize: [2, 3],
                  fontFamily: "roc",
                },
              }}
            >
              <AnimateText
                type="heading"
                as="h2"
                variant="h2"
                sx={{
                  mb: [3, 4, 4, 4],
                  mt: 0,
                  color: "light",
                  textTransform: "uppercase",
                }}
              >
                {title}
              </AnimateText>
              <SlideInComponent
                sx={{
                  height: "100%",
                  "div": {
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                  },
                }}
              >
                <RichContentStructuredText text={body} theme="dark" />
              </SlideInComponent>
            </Box>
          </Flex>
        </Container>
      </Grid>
    </Box>
  )
}

export default HomeAboutUsPartOne
